import React, { useState, useMemo } from 'react';
import {
  Home as HomeIcon,
  AddTask as AddTaskIcon,
  MonitorHeart as VitalsIcon,
  Description as CccIcon,
  AssignmentInd as DepartmentIcon,
  Apartment as ApartmentIcon,
  MedicalServices as MedicalServicesIcon,
  Assessment as ReportIcon,
  PriceCheck as PriceLookupIcon,
} from '@mui/icons-material';
import CreditScoreIcon from '@mui/icons-material/CreditScore';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import PatientInformation from './PatientInformation';
import PatientVitals from './PatientVitals';
import Ccc from './Ccc';
import PatientRegistrationDashboard from './PatientRegistrationDashboard';
// Records is the source of truth for the facility roster (referring sites
// and onboarded doctors), so the same two pages from the Admin Panel are
// exposed here. They're self-contained components — no admin context — so
// the Records desk can add a new external clinic or onboard a doctor
// without going through an administrator.
import FacilitiesManagement from '../AdminPanel/FacilitiesManagement';
import OnboardedDoctors from '../AdminPanel/OnboardedDoctors';
import ReferringDoctorReport from './ReferringDoctorReport';
import PriceLookup from './PriceLookup';

export default function Record() {
  // Shared state — Home writes selectedPatient when editing,
  // PatientInformation reads it.
  const [selectedPatient, setSelectedPatient] = useState(null);

  const menuItems = useMemo(() => [
    {
      key: 'RecordsDashboard',
      label: 'Home',
      icon: <CreditScoreIcon />,
      component: PatientRegistrationDashboard,
    },
    {
      key: 'Home',
      label: 'Records',
      icon: <HomeIcon />,
      render: ({ navigate }) => (
        <Home
          onAddNewPatient={() => {
            setSelectedPatient(null);
            navigate('PatientInformation');
          }}
          onEditPatient={(p) => {
            setSelectedPatient(p);
            navigate('PatientInformation');
          }}
        />
      ),
    },
    {
      key: 'PatientInformation',
      label: 'Patient Information',
      icon: <AddTaskIcon />,
      render: ({ navigate }) => (
        <PatientInformation
          selectedPatient={selectedPatient}
          onPatientSaved={() => {
            setSelectedPatient(null);
            navigate('PatientInformation');
          }}
        />
      ),
    },
    { key: 'PatientVitals', label: 'Patient Vitals', icon: <VitalsIcon />, component: PatientVitals },
    { key: 'Ccc',           label: 'CCC',            icon: <CccIcon />,    component: Ccc },
    { key: 'FacilitiesManagement',  label: 'Facilities Management',   icon: <ApartmentIcon />,        component: FacilitiesManagement },
    { key: 'OnboardedDoctors',      label: 'Onboarded Doctors',       icon: <MedicalServicesIcon />,  component: OnboardedDoctors },
    { key: 'ReferringDoctorReport', label: 'Referring Doctor Report', icon: <ReportIcon />,           component: ReferringDoctorReport },
    { key: 'PriceLookup',           label: 'Price Lookup',            icon: <PriceLookupIcon />,      component: PriceLookup },
  ], [selectedPatient]);

  return (
    <DepartmentLayout
      departmentId={1}
      departmentName="Medical Records"
      departmentIcon={<DepartmentIcon />}
      menuItems={menuItems}
    />
  );
}
